// modifer: styles/jss/nextjs-material-kit-pro/pages/sectionsSections/teamsStyle
import { section, container } from 'styles/jss/original/base';

const styles = {
  section,
  container,
  flex: {
    display: 'flex'
  },
  textWrapper: {
    padding: '30px 0',
    textAlign: 'center',
    '@media (max-width: 640px)': {
      padding: '40px 0'
    }
  },
  imgLoading: {
    width: '128px'
  }
};

export default styles;
